import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { InadimplenciaHistoricalOverview } from '@/features/inadimplencia/types/InadimplenciaHistoricalOverview.ts';

async function getInadimplenciaHistoricalOverview(params): Promise<InadimplenciaHistoricalOverview> {
  const api = await getApi();
  const { data } = await api.get<InadimplenciaHistoricalOverview>('/inadimplencia/historical_overview/', {params});
  return data;
}

type QueryFnType = typeof getInadimplenciaHistoricalOverview;

function useInadimplenciaHistoricalOverview(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-inadimplencia-historical_overview', params],
    queryFn: () =>  getInadimplenciaHistoricalOverview(params),
  });
}

export { useInadimplenciaHistoricalOverview };
